import React, { useState } from "react";
import StandardCard from "./StandardCard";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";
import ReactPaginate from "react-paginate";
import "./StandardCardList.scss"; // custom styles for pagination

const ITEMS_PER_PAGE = 10;

const StandardCardList = ({
  filteredStandards,
  expandedStandards,
  toggleStandardExpansion,
  openAddRequirementModal,
  openDeleteModal,
  searchTerm,
  setShowAddStandardModal,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const offset = currentPage * ITEMS_PER_PAGE;
  const currentItems = filteredStandards.slice(offset, offset + ITEMS_PER_PAGE);
  const pageCount = Math.ceil(filteredStandards.length / ITEMS_PER_PAGE);

  if (filteredStandards.length === 0) {
    return (
      <Card sx={{ textAlign: "center", py: 6, borderRadius: "16px" }}>
        <CardContent>
          <SettingsIcon sx={{ fontSize: 64, color: "grey.300", mb: 2 }} />
          <Typography variant="h6" sx={{ mb: 2 }}>
            No standards found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {searchTerm
              ? "No standards match your search criteria."
              : "Get started by adding your first standard."}
          </Typography>
          {!searchTerm && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setShowAddStandardModal(true)}
            >
              Add Your First Standard
            </Button>
          )}
        </CardContent>
      </Card>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      {currentItems.map((standard, index) => (
        <StandardCard
          key={index}
          standard={standard}
          expanded={!!expandedStandards[standard.standard]}
          toggleStandardExpansion={toggleStandardExpansion}
          openAddRequirementModal={openAddRequirementModal}
          openDeleteModal={openDeleteModal}
        />
      ))}

      {pageCount > 1 && (
        <div className="flex justify-center mt-4 optionClass">
          <ReactPaginate
             previousLabel={"Previous"}
             nextLabel={"Next"}
             pageCount={pageCount}
             onPageChange={handlePageClick}
             containerClassName={"pagination"}
             activeClassName={"active"}
             previousClassName={"page-item"}
             nextClassName={"page-item"}
             pageClassName={"page-item"}
             pageLinkClassName={"page-link"}
             previousLinkClassName={"page-link"}
             nextLinkClassName={"page-link"}
             breakLabel={"..."}
             breakClassName={"page-item"}
             breakLinkClassName={"page-link"}
             disabledClassName={"disabled"}
             pageRangeDisplayed={3}
             marginPagesDisplayed={1}
          />
        </div>
      )}
    </Box>
  );
};

export default StandardCardList;
